import { Component } from '@angular/core';
import { DataService } from 'src/app/services/data.service';
import { MessageService } from 'src/app/services/message.service';

@Component({
  selector: 'app-obs-hr',
  templateUrl: './obs-hr.component.html',
  styleUrls: ['./obs-hr.component.css']
})
export class ObsHrComponent {
  url: string = '';
  searchText = '';
  filteredData: Array<any> = [];
  sugerenciasBusqueda: string[] = [];
  data: Array<any> = [];

  resumenCards = [
    {
      label: '',
      value: '', //0
      icon: 'fas fa-globe',
      bgClass: 'bg-white',
      desc: 'SEO',
      route: '/observability/seo/metricsDaily',
    },
    {
      label: '',
      value: '', //0
      icon: 'fas fa-arrow-trend-up',
      bgClass: 'bg-white',
      desc: 'ADS',
      route: '/observability/ads',
    },
    {
      label: '',
      value: '', //0
      icon: 'fa-solid fa-people-line',
      bgClass: 'bg-white',
      desc: 'SOCIAL',
      route: '/observability/social',
    },
    {
      label: '',
      value: '', //0
      icon: 'fas fa-globe',
      bgClass: 'bg-white',
      desc: 'MEDIAROOM',
      route: '/observability/mediaroom',
    },
    {
      label: '',
      value: '', //0
      icon: 'fas fa-arrow-trend-up',
      bgClass: 'bg-white',
      desc: 'LOGISTICS',
      route: '/observability/logistics',
    },
    {
      label: '',
      value: '', //0
      icon: 'fa-solid fa-receipt',
      bgClass: 'bg-white',
      desc: 'ACCOUNTING',
      route: '/observability/accounting',
    },
    {
      label: '',
      value: '', //0
      icon: 'fa-solid fa-coins',
      bgClass: 'bg-white',
      desc: 'FINANCE',
      route: '/observability/finance',
    },
    {
      label: '',
      value: '', //0
      icon: 'fa-solid fa-people-line',
      bgClass: 'bg-white',
      desc: 'HR',
      route: '/observability/hr',
    },
  ];
  constructor(
    private dataService: DataService,
    private messageService: MessageService
  ) {}

  getData() {
    /* this.dataService.getData(this.url).subscribe((response) => {
      console.log('response en ads', response);

      if (response) {
        this.data = response.data;
      } else {
        this.messageService.add(response.msg, 'secondary');
      }
    }); */
  }

  filterInfo() {
    const texto = this.searchText.trim().toLowerCase();
    //console.log('texto',texto);
    if (!texto) {
      this.filteredData = [...this.data];
    } else {
      this.filteredData = this.data.filter((item) => {
        return (
          (item.firstname && item.firstname.toLowerCase().includes(texto)) ||
          (item.lastname && item.lastname.toLowerCase().includes(texto))
          //(item.phone && item.phone.toLowerCase().includes(texto)) ||
          //(item.role &&
          //  item.role.name &&
          //  item.role.name.toLowerCase().includes(texto)) ||
          //(item.rol_user && item.rol_user.toLowerCase().includes(texto)) ||
          //(item.state && item.state.toLowerCase().includes(texto)) ||
          //(item.city && item.city.toLowerCase().includes(texto))
        );
      });
      //console.log('filteredData',this.filteredData);
    }
    this.getStatsFiltrado();
    this.getResumenEstadosFiltrado();
  }

  getStatsFiltrado() {
    /* this.totalConductores = this.filteredData.length;
    this.totalActivos = this.filteredData.filter((d) => d.status).length;
    this.totalInactivos = this.filteredData.filter((d) => !d.status).length;
    this.ultimoRegistro = this.filteredData.length
      ? this.filteredData[this.filteredData.length - 1].firstname +
        ' ' +
        this.filteredData[this.filteredData.length - 1].lastname
      : '-'; */
  }

  getResumenEstadosFiltrado() {
    /* this.totalNumber = this.filteredData.length;
    this.byCities = new Set(this.filteredData.map((d) => d.city)).size;
    this.active = this.filteredData.filter((d) => d.status === 'active').length;
    this.busy = this.filteredData.filter((d) => d.status === 'busy').length;
    this.pending = this.filteredData.filter(
      (d) => d.status === 'pending'
    ).length;
    this.sanctioned = this.filteredData.filter(
      (d) => d.status === 'sanctioned'
    ).length;

    this.resumenCards[0].value = this.totalConductores;
    this.resumenCards[1].value = this.byCities;
    this.resumenCards[2].value = this.totalActivos;
    this.resumenCards[3].value = this.busy;
    this.resumenCards[4].value = this.totalInactivos;
    this.resumenCards[5].value = this.sanctioned; */
  }

}
